/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import React     from 'react';
import PropTypes from 'prop-types';
import styles    from 'components/FlowFooter/FlowFooter.scss';

export default class FlowFooter extends React.Component {
  constructor() {
    super();
  }

  render() {

    let classes = [styles.footer]

    if (this.props.customClass) {
      classes.push(styles[this.props.customClass]);
    }

    if (this.props.shouldShowFooter) {
      classes.push(styles['ShowFooter']);
    }

    return (
      <div className={classes.join(' ')}>
        <div role='alert' className={[styles.content, this.props.errorMessage ? styles.error : ''].join(' ')}>
          {this.props.errorMessage || this.props.children}
        </div>
        <div className={styles.right}>
          {this.props.secondary || null}
          {this.props.primary || null}
        </div>
      </div>
    );
  }
}


FlowFooter.propTypes = {
  primary: PropTypes.node,
  secondary: PropTypes.node,
  errorMessage: PropTypes.node,
  customClass: PropTypes.string,
  borderTop: PropTypes.string,
  children: PropTypes.node,
}
